import axios from 'axios';
import { REACT_APP_API_ABM } from '../../config';

export async function getPrices({search}){
    try{
        return await axios.get(`${REACT_APP_API_ABM}/pricesProcess${search}`).then(result=>result.data);
    }catch(error){
        throw new Error(error)
    }
}
